// src/components/university/marketplace/InstructorCoursesEmbed.js
// Componente reutilizable: dado un user_id (auth.users), muestra los cursos
// publicos del instructor asociado (si existe). Lo usamos en:
//   - /u/:userId (PublicProfilePage)
//   - /:slug y /empresa/:slug (CompanyPublicWebsite)
//
// Si el usuario no es instructor activo o no tiene cursos publicados, no renderiza nada.

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiAward } from 'react-icons/fi';
import supabase from '../../../supabase';
import instructorService from '../../../services/university/instructorService';
import CourseCard from './CourseCard';

const InstructorCoursesEmbed = ({ userId, dark = true }) => {
  const [profile, setProfile] = useState(null);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) { setLoading(false); return; }
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const { data: ip } = await supabase
          .from('university_instructor_profiles')
          .select('id, status, display_name, public_slug')
          .eq('user_id', userId)
          .maybeSingle();
        if (!mounted) return;
        if (!ip || ip.status !== 'active') { setLoading(false); return; }
        setProfile(ip);
        const list = await instructorService.getPublicCourses(ip.id, 6);
        if (mounted) setCourses(list);
      } catch (err) {
        console.error(err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [userId]);

  if (loading || !profile || courses.length === 0) return null;

  const profilePath = `/universidad/instructor/${profile.public_slug || profile.id}`;

  return (
    <section className={`${dark ? 'bg-dark-800 border border-dark-700' : 'bg-white border border-gray-200'} rounded-xl p-5 sm:p-6`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <h2 className={`text-xl font-semibold inline-flex items-center gap-2 ${dark ? 'text-white' : 'text-gray-900'}`}>
          <FiAward size={18} className="text-primary-400" />
          Cursos de {profile.display_name} en AVlink University
        </h2>
        <Link
          to={profilePath}
          className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300"
        >
          Ver todos <FiArrowRight size={14} />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.slice(0, 3).map((c) => (
          <CourseCard key={c.id} course={c} />
        ))}
      </div>
    </section>
  );
};

export default InstructorCoursesEmbed;
